import { apiGet } from './client';
import type { FundDataHistory } from '../types/FundDataHistory';

// All three params are required by the backend (GET /api/fund-data-history —
// reads dbo.FundDataHistory_viewHis, ordered by dDate). fromDate/toDate are
// 'YYYY-MM-DD'.
export function getFundDataHistory(
  fundId: number,
  fromDate: string,
  toDate: string,
): Promise<FundDataHistory[]> {
  const qs = new URLSearchParams({
    fundId: String(fundId),
    fromDate,
    toDate,
  });
  return apiGet<FundDataHistory[]>(`/api/fund-data-history?${qs.toString()}`);
}
